(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skynex-campaign"] && !Shopify.designMode) return;
  try {
    
(()=>{const setup=root=>root.querySelectorAll('[data-campaign-toggle]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.hidden=false;const section=button.closest('.skx-campaign');const preference=matchMedia('(prefers-reduced-motion: reduce)');let paused=preference.matches;const sync=()=>{section.dataset.paused=String(paused||preference.matches);button.textContent=paused||preference.matches?button.dataset.resume:button.dataset.pause;button.setAttribute('aria-pressed',String(!paused&&!preference.matches));};button.addEventListener('click',()=>{paused=!paused;sync();});preference.addEventListener('change',()=>{paused=preference.matches;sync();});sync();});setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));})();

  } catch(e) { console.error(e); }
})();
})();
